import { useTranslations } from 'modules/templateEditor/hooks/useTranslations';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Image16 } from 'ui/icons';
import { ContentModals, ContentModalStateType, useModalContext } from 'utils/contexts/modal';

export const CreativeLibraryButton = () => {
  const { showModal } = useModalContext<ContentModalStateType>();
  const { t } = useTranslations();

  return (
    <Button
      data-test={'creative-library-button'}
      onClick={() => showModal({ modal: ContentModals.CreativeLibrary })}
      size={BUTTON_SIZES.MEDIUM}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <Image16 isColorInherited />
      <span>{t('button.images')}</span>
    </Button>
  );
};

export default CreativeLibraryButton;
